import _ from 'lodash';
import React, { PropTypes } from 'react';
import InputRange from 'react-input-range';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './../../../../actions/actions';

class Range extends React.Component {
    constructor(props) {
        super(props);
        this.handleValuesChange = this.handleValuesChange.bind(this);
    }

    handleValuesChange(component, values) {
        if (this.props.mode === 'EDIT') {
            return false;
        }
        if (this.props.widget.multi) {
            this.props.actions.setRangeUserValues(this.props.widget.id, values);
        } else {
            this.props.actions.setRangeSingleValue(this.props.widget.id, values);
        }

        if (this.props.mode === 'CLIENT') {
            this.props.actions.saveResult(this.props.activeId, this.props.widget.type, 1);
        }
    }

    render() {
        const { widget } = this.props;
        let values;

        if (widget.multi) {
            values = { min: widget.dMin, max: widget.dMax };
        } else {
            values = widget.singleValue;
        }

        return (
            <div>
                <InputRange
                    maxValue={widget.sMax}
                    minValue={widget.sMin}
                    step={widget.step}
                    value={values}
                    onChange={this.handleValuesChange}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    mode: state.app.mode,
    activeId: state.pages.activeId,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Range.propTypes = {
    activeId: PropTypes.number.isRequired,
    widget: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Range);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/Widgets/Range/Range.jsx